import i18n from "../i18n";

export const SEO_BASE_URL = "https://reelitpro.com";
export const REELITPRO_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.reelitpro.app";

export const DEFAULT_SEO = {
  titleKey: "seo.default.title",
  descriptionKey: "seo.default.description",
  path: "/",
};

export const ROUTE_SEO = {
  "/": DEFAULT_SEO,
  "/fishipedia": {
    titleKey: "seo.routes.fishipedia.title",
    descriptionKey: "seo.routes.fishipedia.description",
    path: "/fishipedia",
  },
  "/fishipedia/rankings": {
    titleKey: "seo.routes.fishipediaRankings.title",
    descriptionKey: "seo.routes.fishipediaRankings.description",
    path: "/fishipedia/rankings",
  },
  "/regulations": {
    titleKey: "seo.routes.regulations.title",
    descriptionKey: "seo.routes.regulations.description",
    path: "/regulations",
  },
  "/support": {
    titleKey: "seo.routes.support.title",
    descriptionKey: "seo.routes.support.description",
    path: "/support",
  },
  "/login": {
    titleKey: "seo.routes.login.title",
    descriptionKey: "seo.routes.login.description",
    path: "/login",
  },
  "/register": {
    titleKey: "seo.routes.register.title",
    descriptionKey: "seo.routes.register.description",
    path: "/register",
  },
  "/fishing-app": {
    titleKey: "seo.routes.fishingApp.title",
    descriptionKey: "seo.routes.fishingApp.description",
    path: "/fishing-app/",
  },
  "/fishing-catch-log-app": {
    titleKey: "seo.routes.fishingCatchLogApp.title",
    descriptionKey: "seo.routes.fishingCatchLogApp.description",
    path: "/fishing-catch-log-app/",
  },
  "/fishing-spots-app": {
    titleKey: "seo.routes.fishingSpotsApp.title",
    descriptionKey: "seo.routes.fishingSpotsApp.description",
    path: "/fishing-spots-app/",
  },
  "/fishing-trip-planner": {
    titleKey: "seo.routes.fishingTripPlanner.title",
    descriptionKey: "seo.routes.fishingTripPlanner.description",
    path: "/fishing-trip-planner/",
  },
  "/fish-species-guide": {
    titleKey: "seo.routes.fishSpeciesGuide.title",
    descriptionKey: "seo.routes.fishSpeciesGuide.description",
    path: "/fish-species-guide/",
  },
  "/fishing-regulations": {
    titleKey: "seo.routes.fishingRegulations.title",
    descriptionKey: "seo.routes.fishingRegulations.description",
    path: "/fishing-regulations/",
  },
  "/legal/account-deletion": {
    titleKey: "seo.routes.accountDeletion.title",
    descriptionKey: "seo.routes.accountDeletion.description",
    path: "/legal/account-deletion",
  },
};

function translateSeoEntry(entry) {
  return {
    ...entry,
    title: i18n.t(entry.titleKey),
    description: i18n.t(entry.descriptionKey),
  };
}

export function buildCanonicalUrl(path = "/") {
  return `${SEO_BASE_URL}${path === "/" ? "/" : path}`;
}

export function getSeoForPath(pathname) {
  const normalizedPath =
    pathname && pathname !== "/" ? pathname.replace(/\/+$/, "") : "/";

  return translateSeoEntry(ROUTE_SEO[normalizedPath] || DEFAULT_SEO);
}

export function buildHomepageSoftwareApplicationJsonLd() {
  const defaultSeo = translateSeoEntry(DEFAULT_SEO);

  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "ReelitPro",
    applicationCategory: "LifestyleApplication",
    operatingSystem: "Android, Web",
    url: buildCanonicalUrl("/"),
    installUrl: REELITPRO_PLAY_STORE_URL,
    sameAs: [REELITPRO_PLAY_STORE_URL],
    description: defaultSeo.description,
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  };
}
